const UNINDEXED_TYPE_NAMES = new Set([
    'Dimensional',
    'MultiDimensional',
    'Image',
    'Document',
]);

const isWebLinkRenderer = (renderer: unknown): boolean => {
    if (renderer === 'WebLink') {
        return true;
    }
    if (Array.isArray(renderer)) {
        return renderer.some((entry) => (
            entry === 'WebLink'
            || (typeof entry === 'object' && entry != null && (
                (entry as { value?: unknown }).value === 'WebLink'
                || (entry as { key?: unknown }).key === 'WebLink'
            ))
        ));
    }
    return false;
};

const isTruthyParam = (value: unknown): boolean =>
    value === true || value === 'true' || value === 1 || value === '1';

/**
 * Browse / catalog hit-list columns the search index cannot sort must not
 * offer a sort caret and must never be sent as `sort=` (LAX-10282).
 *
 * Matches AngularJS `DataModel#isHitListColumnSortable`.
 *
 * Live DemoModel `/api/v1/datamodel/current` browse columns that 400 today:
 * Image, Document, WebLink (`childrenLink`). Plus `disableSearchIndex`
 * (`simple_unsearchable_text`) and Dimensional (existing rule).
 */
export const isHitListColumnSortable = (
    attribute?: {
        typeName?: string;
        params?: {
            disableSearchIndex?: boolean | string | number;
            disable_search_index?: boolean | string | number;
            virtual?: boolean | string | number;
            renderer?: unknown;
        };
    } | null,
): boolean => {
    if (!attribute) {
        return false;
    }
    if (attribute.typeName && UNINDEXED_TYPE_NAMES.has(attribute.typeName)) {
        return false;
    }
    const params = attribute.params;
    if (isTruthyParam(params?.disableSearchIndex) || isTruthyParam(params?.disable_search_index)) {
        return false;
    }
    if (isTruthyParam(params?.virtual)) {
        return false;
    }
    if (isWebLinkRenderer(params?.renderer)) {
        return false;
    }
    return true;
};

export const filterHitListSorting = <T extends { id: string }>(
    sorting: T[],
    isColumnSortable: (columnId: string) => boolean,
): T[] => sorting.filter((entry) => isColumnSortable(entry.id));
